export default __webpack_public_path__ + "3abb5c8076fc624980bb43f5cf92e561.svg";